import { STATUS } from '../../../../constants/commonConstants';

export const PRODUCT_STATUS = {
  checkPrice: 'CHECK_PRICE',
  directReplacement: 'DIRECT_REPLACEMENT',
  indirectReplacement: 'INDIRECT_REPLACEMENT',
  priceCallFailure: 'PRICE_CALL_FAILURE',
  priceCallLoading: 'PRICE_CALL_LOADING',
  priceZero: 'PRICE_ZERO',
  purchaseAvailable: 'PURCHASE_AVAILABLE',
  purchaseUnavailable: 'PURCHASE_UNAVAILABLE',
  unknown: 'UNKNOWN',
  discontinued: 'DISCONTINUED'
};

const getSuccessfulPricingStatus = (
  isPricingAvailable,
  indirectReplacement,
  isReplaced,
  isZeroPrice
) => {
  let status;
  if (indirectReplacement) {
    status = PRODUCT_STATUS.indirectReplacement;
  } else if (isReplaced) {
    status = PRODUCT_STATUS.directReplacement;
  } else if (isZeroPrice) {
    status = PRODUCT_STATUS.priceZero;
  } else if (isPricingAvailable) {
    status = PRODUCT_STATUS.purchaseAvailable;
  } else {
    status = PRODUCT_STATUS.purchaseUnavailable;
  }

  return status;
};

export const getProductPurchaseStatus = ({
  enableAddToCart,
  formattedZeroPrice,
  indirectReplacement,
  isCatCorp,
  isGuest,
  isInstantAccess,
  priceCallStatus,
  registrationPendingApproval,
  replacementParts,
  unitPrice,
  isDiscontinuedCTA
}) => {
  const didPriceLoadFail = priceCallStatus === STATUS.REJECTED;
  const didPriceLoadSuccessfully = priceCallStatus === STATUS.RESOLVED;
  const isNonIAGuest = isGuest && !isInstantAccess;
  const isPriceLoading = priceCallStatus === STATUS.PENDING;
  const isPricingAvailable = unitPrice && enableAddToCart;
  const isReplaced =
    Array.isArray(replacementParts) && replacementParts.length > 0;
  const isZeroPrice = unitPrice === formattedZeroPrice;

  let status;
  if (isDiscontinuedCTA && !isReplaced) {
    status = PRODUCT_STATUS.discontinued;
  } else if (isCatCorp || isNonIAGuest) {
    status = PRODUCT_STATUS.checkPrice;
  } else if (registrationPendingApproval) {
    status = PRODUCT_STATUS.purchaseAvailable;
  } else if (didPriceLoadFail) {
    status = PRODUCT_STATUS.priceCallFailure;
  } else if (isPriceLoading) {
    status = PRODUCT_STATUS.priceCallLoading;
  } else if (didPriceLoadSuccessfully) {
    status = getSuccessfulPricingStatus(
      isPricingAvailable,
      indirectReplacement,
      isReplaced,
      isZeroPrice
    );
  } else {
    status = PRODUCT_STATUS.unknown;
  }

  return status;
};
